import { render, staticRenderFns } from "./dashboard-quiz-response.vue?vue&type=template&id=119b2c50&scoped=true&"
import script from "./dashboard-quiz-response.vue?vue&type=script&lang=js&"
export * from "./dashboard-quiz-response.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-quiz-response.vue?vue&type=style&index=0&id=119b2c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b2c50",
  null
  
)

export default component.exports